import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "../../styles/MaterialUI";
import axios from "axios";
import apiConstants from "../../constants/apiConstants";
import { useDispatch, useSelector } from "react-redux";
import TroubleShootLayout from "../MonitoringTool/TroubleShootLayout";
import { showAlertPopup } from "../Redux/Features/showAlertSlice";
import { useOrgConfigData } from "../../hooks/useOrgConfigData";
const ScreenMetrics = () => {
  const { reloadStatus } = useSelector((state) => state.reloadMetrics);
  const { userToken } = useSelector((state) => state.userToken);
  const [metricsCount, setMetricsCount] = useState([]);
  const headers = { Authorization: `Bearer ${userToken}` };
  const dispatch = useDispatch();
  const orgConfig = useOrgConfigData("ScreenMetrics");


  const StyledTableCell = styled(TableCell)({
    borderRight: "1px solid #e0e0e0",
    textAlign: "center",
    color: "#fff",
    letterSpacing: 1,
    fontSize: "1rem",
    background: "linear-gradient(60deg, #003366, #003366)",
  });

  const TableCellStyle = {
    borderRight: "1px solid #e0e0e0",
    textAlign: "center",
    letterSpacing: 1,
    fontSize: "1rem",
    backgroundColor: "#fff",
  };

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${apiConstants.GET_API_URL}getUnutilizedScreensCount`,
        {},
        { headers }
      );

      setMetricsCount(response.data);
    } catch (error) {
      const { statusCode, message, redirect_url } = error.response.data;
      dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
      if (statusCode === 403) {
        window.open(redirect_url, "_self");
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [orgConfig]);

  

  useEffect(() => {
    if (reloadStatus === true) {
      fetchData();
    }
  }, [reloadStatus]);

  return (
    <Grid container item xs={12} sx={{ marginTop: "40px" }}>
      <TableContainer
        component={Paper}
        sx={{
          margin: "10px",
          border: "1px solid #003366",
          boxShadow: "0px 3px 15px rgba(34, 35, 58, 0.3)",
        }}
      >
        <Table size="small" aria-label="screenMetrics">
          <TableHead>
            <TableRow>
              <StyledTableCell className="styled-header" rowSpan={2}>
                Number of Subscribed Screens
              </StyledTableCell>
              <StyledTableCell className="styled-header" colSpan={5}>
                Number of Paired Screens
              </StyledTableCell>
              <StyledTableCell className="styled-header" rowSpan={2}>
                Number of Unutilized Screens
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell className="styled-header">
                Paired
              </StyledTableCell>
              <StyledTableCell className="styled-header">
                Active
              </StyledTableCell>
              <StyledTableCell className="styled-header">Idle</StyledTableCell>
              <StyledTableCell className="styled-header">
                Deactivated
              </StyledTableCell>
              <StyledTableCell className="styled-header">
                Offline
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={TableCellStyle}>
                {metricsCount.subscribedScreens}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.statuses?.pairedScreensCount}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.statuses?.activeScreensCount}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.statuses?.idleScreensCount}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.statuses?.deactivatedScreensCount}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.statuses?.offlineScreensCount}
              </TableCell>
              <TableCell style={TableCellStyle}>
                {metricsCount.unutilizedScreensCount}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TroubleShootLayout />
    </Grid>
  );
};

export default ScreenMetrics;
